import { IJsonQuery, ESuburbanUtility } from '../json_query';

export function utilitiesFromJsonQuery(jsonQuery: IJsonQuery): ESuburbanUtility[] {
  return (Object.keys(ESuburbanUtility) as (keyof typeof ESuburbanUtility)[]).reduce((previousValue, currentValue) => {
    const facility = ESuburbanUtility[currentValue];
    if (jsonQuery[facility] !== undefined) {
      previousValue.push(facility);
    }

    return previousValue;
  }, [] as ESuburbanUtility[]);
}
